import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { ShapeSettings } from '../setting/ShapeSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;
/**
 * 固定の繰り返し
 * deprecated 固定の繰り返し動的な繰り返しとの連動を検討
 */
export class RangeLoopBlock extends AbstractBlock {
  constructor() {
    super('logic_range-loop_v2', t.to('固定の繰り返し', 'logic_loop'));
    this.setNameForCode('range-loop');
  }
  defineBlock(block: BlockType): void {
    ColorSettings.setLogicColor(block);
    ShapeSettings.setElementWithSubBlockShape(block);

    // フィールド
    const min = new Blockly.FieldTextInput('0');
    const max = new Blockly.FieldTextInput('10');
    const counter = new Blockly.FieldTextInput('x');

    // 属性値の入力フィールド
    block
      .appendDummyInput()
      .appendField(t.to('変数', 'range_loop1'))
      .appendField(counter, 'COUNTER_VAR')
      .appendField(t.to('をカウントして', 'range_loop2'))
      .appendField(min, 'RANGE_MIN')
      .appendField(t.to('から', 'range_loop3'))
      .appendField(max, 'RANGE_MAX')
      .appendField(t.to('まで繰り返す', 'range_loop4'));

    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const min = CodeSetting.getNumberFieldValue(block, 'RANGE_MIN');
    const max = CodeSetting.getNumberFieldValue(block, 'RANGE_MAX');
    const counter = CodeSetting.getFieldValue(block, 'COUNTER_VAR');
    const input = CodeSetting.getSubstatementCode(block);

    const str = `for( let ${counter} = ${min}; ${counter} <= ${max}; ${counter}++ ){
			${input}
		}`;

    return str;
  }
}
